import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./interes.css";
import { Interes_item } from "../../json/interes";

const Interes = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const linkStyle = {
    textDecoration: "none",
  };

  return (
    <div className="container interes-container">
      <div className="row">
        <div className="col_12">
          <div className="interes_title">
            <h1>Ligas de Interés</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {Interes_item.map((item, index) => (
          <div key={index} className="col-md-4 interes-card">
            <Link style={linkStyle} to={item.url}>
            <div className='interes_container'>
                    <div className='interes_icono'>
                      <img src={"/img/icons/" + item.icon }/>
                    </div>
                    <h3>{ item.nombre }</h3>
                  </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Interes;
